import { stylesheet } from 'typestyle';
import { Gray120, IconView, typeCompact14RegularProperties, typeCompact20DisplayProperties } from '@traceair/tds';
import { DroneOffIcon, FilterIcon, SearchIcon, SiteIcon } from '@traceair/webapp-icons';
import { MissionTab } from '../../../../consts/missionTab';
import { useAppStore } from '../../../../store/appStore';
import { useSelectedMissionsTab } from '../useSelectedMissionsTab';

const css = stylesheet({
  container: {
    padding: 32,
    textAlign: 'center',
  },
  heading: {
    margin: '12px 0 6px',
    ...typeCompact20DisplayProperties,
  },
  note: {
    color: Gray120,
    whiteSpace: 'pre-wrap',
    ...typeCompact14RegularProperties,
  },
});

export const NotFound = () => {
  const selectedMissionsTab = useSelectedMissionsTab();
  const { missionFilter, projectSearch } = useAppStore();

  let icon = {
    [MissionTab.Schedules]: <DroneOffIcon />,
    [MissionTab.Uploaded]: <DroneOffIcon />,
    [MissionTab.AllProjects]: <SiteIcon />,
  }[selectedMissionsTab];

  let heading = {
    [MissionTab.Schedules]: 'No missions',
    [MissionTab.Uploaded]: 'No unprocessed uploaded missions',
    [MissionTab.AllProjects]: 'No projects',
  }[selectedMissionsTab];

  let note = {
    [MissionTab.Schedules]: 'Missions will appear here as soon as\nthe OPS team assigns them to you',
    [MissionTab.Uploaded]: 'Uploaded missions remain here until\nthey are processed',
    [MissionTab.AllProjects]: 'Projects will appear here once they\nare assigned to you',
  }[selectedMissionsTab];

  if (projectSearch) {
    icon = <SearchIcon />;
    heading += ' found';
    note = 'Adjust your search to try again';
  } else if (missionFilter && selectedMissionsTab === MissionTab.Schedules) {
    icon = <FilterIcon />;
    heading += ' found';
    note = 'Adjust the filter to try again';
  }

  return (
    <div className={css.container}>
      <IconView icon={icon} size="xl" type="square" />
      <div className={css.heading}>{heading}</div>
      <div className={css.note}>{note}</div>
    </div>
  );
};
